import axios from "axios";

type fetchParams = {
  components: string;
  language: string;
  types: string;
};

// this could be extended to support multiple providers
const autocompleteStrategies = {
  woosmap: {
    fetchSuggestion(params: fetchParams, query: string) {
      return axios.get(`https://api.woosmap.com/localities/autocomplete/`, {
        params: {
          key: process.env.NEXT_PUBLIC_WOOSMAP_API_KEY,
          ...params,
          input: query,
        },
      });
    },
    fetchDetails(publicId: string) {
      return axios.get(`https://api.woosmap.com/localities/details/`, {
        params: {
          key: process.env.NEXT_PUBLIC_WOOSMAP_API_KEY,
          public_id: publicId,
        },
      });
    },
  },
};

export default autocompleteStrategies;
